import styled from "@emotion/styled"
import Button from "components/Buttons/Button"

const CTAFormFinalBtn = styled(Button)``

export default CTAFormFinalBtn
